import { IFormSite } from './site.i';

export class CFormSite implements IFormSite {
  id = 0;
  libelle = '';
  postal = '';
  ville: string = undefined;

  constructor(source?: IFormSite) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        libelle: source.libelle,
        postal: source.postal,
        ville: source.ville
      });
    }
  }
}
